import React from 'react';
import { overrideRessource } from 'generic/utils/utils';

const Document = overrideRessource('components/documents/Document');

const DocumentWrapper = ({ ...rest }) => <Document {...rest} />;

export default DocumentWrapper;
